import {BackendApi} from "../../../../../../api/api.ts";
import {Business} from "../../../../admin/pages/businessesOverviewPage/BusinessesOverviewPage.tsx";
import LoadingFrame from "../../../../../../components/LoadingFrame.tsx";
import DailyBalanceGraph from "../../../../entrepreneur/pages/BalancePage/DailyBalanceGraph.tsx";
import {useEffect, useState} from 'react';
import RelativeLoadingFrame from "../../../../../../components/RelativeLoadingFrame.tsx";
import {ClientData} from "../PartnerClientSettingsPage.tsx";
import {Client} from "../../../Client.ts";
import {formatOwnerWithAccountIdentifier} from "../../../../../../lib/institutionDisplayNames.ts";
import {BankConsentIndicator, ConsentBankAccount} from "../../../../../../components/general/BankConsentIndicator.tsx";

interface PartnerBankAccount extends ConsentBankAccount {
    account_id: string;
    owner_name: string;
}

export function PartnerClientCashBalanceHistoryChart({client, api}: { client: ClientData, api: BackendApi }) {

    const [bankAccounts, setBankAccounts] = useState<PartnerBankAccount[]>([]);
    async function load() {

        const bankAccountsResponse = await api.Partner__entrepreneur__getBankAccounts(client.id);
        setBankAccounts(bankAccountsResponse)
    }

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        setBankAccounts([]);
        load();
    }, [client]);

    if (!client) {
        return (
            <div>
                Geen klant gevonden.
            </div>
        )
    }

    return (
        <>
            {bankAccounts?.length === 0 && <div className="text-center">Geen bankrekeningen gevonden</div>}
            {bankAccounts?.map((bankAccount) => (

                <div>
                    <h2 className={"text-2xl mt-8 mb-4 flex items-center gap-2"}>
                        {formatOwnerWithAccountIdentifier(
                            bankAccount.owner_name,
                            bankAccount.iban,
                            bankAccount.institution_name,
                        )}
                        <BankConsentIndicator bankAccounts={[bankAccount]} />
                    </h2>
                    <BalanceGraph business={client} api={api} bankAccountId={bankAccount.account_id}/>
                </div>

            ))}
        </>
    )
}

function BalanceGraph({business, api, bankAccountId}: { business: ClientData, api: BackendApi, bankAccountId: string}) {
    const [data, setData] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    async function load() {
        const startDate = new Date(business.transaction_history_cutoff_date).toISOString().split('T')[0] || '2022-01-01T00:00:00';
        const endDate = new Date().toISOString().split('T')[0];
        const response = await api.Partner__graph__business__getDailyBalanceWithForecast(business.id, bankAccountId, startDate, endDate);
        setData(response);
        setIsLoading(false);
    }

    useEffect(() => {
        load();
    }, [business, bankAccountId]);

    if (!business){
        return (
            <div>Geen gegevens gevonden.</div>
        )
    }

    return (
        <div className="relative mt-6 flex-1 px-4 sm:px-6">
            <RelativeLoadingFrame isLoading={isLoading}>
                <DailyBalanceGraph data={data || []} className={"h-[60vh]"}></DailyBalanceGraph>
            </RelativeLoadingFrame>
        </div>
    )
    }

